const catalogueTemplateActions = {
  CLOSE_CATALOGUE_TEMPLATES: 'CLOSE_CATALOGUE_TEMPLATES',
  FETCH_CATALOGUE_TEMPLATE: 'FETCH_CATALOGUE_TEMPLATE',
  FETCH_CATALOGUE_TEMPLATE_FOR_DATASET: 'FETCH_CATALOGUE_TEMPLATE_FOR_DATASET',
  FETCH_CATALOGUE_TEMPLATES: 'FETCH_CATALOGUE_TEMPLATES',
  REFRESH_CATALOGUE_TEMPLATES: 'REFRESH_CATALOGUE_TEMPLATES',
  SHOW_CATALOGUE_TEMPLATE_SUCCESS: 'SHOW_CATALOGUE_TEMPLATE_SUCCESS',
  SHOW_CATALOGUE_TEMPLATE_DATASET_ERROR: 'SHOW_CATALOGUE_TEMPLATE_DATASET_ERROR',
  SHOW_CATALOGUE_TEMPLATE_DATASET_SUCCESS: 'SHOW_CATALOGUE_TEMPLATE_DATASET_SUCCESS',
  SHOW_CATALOGUE_TEMPLATE_ERROR: 'SHOW_CATALOGUE_TEMPLATE_ERROR',
  SHOW_CATALOGUE_TEMPLATES: 'SHOW_CATALOGUE_TEMPLATES',
  SHOW_CATALOGUE_TEMPLATES_ERROR: 'SHOW_CATALOGUE_TEMPLATES_ERROR',
};

export const catalogueSectionNames = ['first', 'second'];

export default catalogueTemplateActions;
